// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Payment Profiles page — only the bits that aren't already in
   regional-offices.css / reports.css. The page reuses .header,
   .reports-layout, .filters-panel, .offices-table, .offices-modal,
   .offices-form-* etc. Everything below is profile-specific. */

/* ─── Global FX margin card (page header) ─── */
.pp-fx-card {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 14px 16px;
  min-width: 240px;
  display: flex; flex-direction: column; gap: 8px;
}
.pp-fx-label {
  font-size: 11px; font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.5px;
}
.pp-fx-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.pp-fx-value {
  font-size: 22px; font-weight: 800; color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  background: linear-gradient(135deg, #FF6B4A, #E94B6C, #8E3A9A);
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent;
}
.pp-fx-edit-btn {
  font-size: 12px; font-weight: 600;
  padding: 6px 12px;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  color: var(--text-primary);
  border-radius: 7px;
  cursor: pointer;
}
.pp-fx-edit-btn:hover { background: var(--bg-tertiary, #f5f6fa); }
.pp-fx-edit { display: flex; flex-direction: column; gap: 8px; }
.pp-fx-edit-row { display: flex; align-items: center; gap: 6px; }
.pp-fx-input {
  flex: 1 1;
  border: 1px solid var(--border-color);
  border-radius: 7px;
  padding: 8px 10px;
  font-size: 16px; font-weight: 600;
  font-variant-numeric: tabular-nums;
  outline: none;
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.pp-fx-input:focus { border-color: #E94B6C; }
.pp-fx-pct { font-size: 14px; font-weight: 600; color: var(--text-secondary); }
.pp-fx-totp {
  border: 1px solid var(--border-color);
  border-radius: 7px;
  padding: 8px 10px;
  font-family: ui-monospace, monospace;
  font-size: 14px;
  letter-spacing: 3px;
  text-align: center;
  outline: none;
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.pp-fx-totp:focus { border-color: #E94B6C; }
.pp-fx-actions { display: flex; gap: 6px; justify-content: flex-end; }
.pp-fx-cancel, .pp-fx-save {
  font-size: 12px; font-weight: 600;
  padding: 7px 14px;
  border-radius: 7px;
  border: none; cursor: pointer;
}
.pp-fx-cancel { background: var(--bg-secondary); color: var(--text-secondary); border: 1px solid var(--border-color); }
.pp-fx-save { background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%); color: #fff; }
.pp-fx-save:disabled, .pp-fx-cancel:disabled { opacity: 0.55; cursor: not-allowed; }
.pp-fx-error { font-size: 11px; color: #c1392b; }
.pp-fx-hint { font-size: 11px; color: var(--text-secondary); line-height: 1.4; }

/* ─── Master active toggle (top of the modal) ─── */
.pp-active-banner {
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 18px;
  border: 1px solid var(--border-color);
  transition: background 0.15s, border-color 0.15s;
}
.pp-active-banner.on {
  background: linear-gradient(180deg, #f4faf6 0%, #ffffff 100%);
  border-color: rgba(20, 118, 78, 0.25);
}
.pp-active-banner.off {
  background: linear-gradient(180deg, #fef0f1 0%, #fff8f8 100%);
  border-color: rgba(193, 57, 43, 0.25);
}
.pp-active-toggle-row {
  display: flex; align-items: flex-start; gap: 12px;
  cursor: pointer;
}
.pp-active-toggle-row input[type="checkbox"] {
  width: 20px; height: 20px;
  accent-color: #E94B6C;
  margin-top: 1px;
  flex-shrink: 0;
}
.pp-active-text { display: flex; flex-direction: column; gap: 3px; }
.pp-active-title {
  font-size: 14px; font-weight: 700;
  color: var(--text-primary);
}
.pp-active-banner.off .pp-active-title { color: #c1392b; }
.pp-active-sub {
  font-size: 12px; line-height: 1.5;
  color: var(--text-secondary);
}

/* ─── Tabs inside the modal ─── */
.pp-tabs-row {
  display: flex; gap: 2px;
  border-bottom: 1px solid var(--border-color);
  margin: 8px 0 16px;
  flex-wrap: wrap;
}
.pp-tab-btn {
  background: none; border: none;
  padding: 10px 14px;
  font-size: 13px; font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.12s, border-color 0.12s;
}
.pp-tab-btn:hover { color: var(--text-primary); }
.pp-tab-btn.active {
  color: var(--text-primary);
  border-bottom-color: #E94B6C;
}

.pp-tab-pane {
  display: flex; flex-direction: column; gap: 14px;
}

.pp-hint {
  margin: 0;
  font-size: 12px; color: var(--text-secondary);
  line-height: 1.5;
  padding: 10px 12px;
  background: var(--bg-tertiary, #f7f7f9);
  border-radius: 8px;
}
.pp-hint strong { color: var(--text-primary); }

/* ─── Secret tag inline next to the field label ─── */
.pp-secret-tag {
  display: inline-block;
  font-size: 9px; font-weight: 800;
  padding: 2px 5px;
  margin-left: 8px;
  background: #fff3f4; color: #E94B6C;
  border-radius: 3px; letter-spacing: 0.6px;
  vertical-align: middle;
}

/* The shared regional-offices.css only styles input/select inside
   .offices-form-field — textarea inherits browser defaults (huge font,
   no padding). Cover it explicitly. */
.offices-form-field textarea,
.pp-textarea {
  width: 100%;
  padding: 12px 14px;
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12px;
  line-height: 1.45;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  resize: vertical;
}
.offices-form-field textarea:focus,
.pp-textarea:focus {
  border-color: #E94B6C;
}
.pp-textarea::placeholder { color: var(--text-secondary); opacity: 0.6; }

/* ─── Webhook URL box ─── */
.pp-webhook-box {
  border: 1px solid var(--border-color);
  border-left: 3px solid #E94B6C;
  border-radius: 8px;
  padding: 12px 14px;
  background: rgba(233, 75, 108, 0.04);
  display: flex; flex-direction: column; gap: 8px;
}
.pp-webhook-label {
  font-size: 12px; font-weight: 600;
  color: var(--text-primary);
}
.pp-webhook-url-row {
  display: flex; gap: 8px; align-items: center;
}
.pp-webhook-url {
  flex: 1 1;
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12px;
  background: var(--bg-secondary);
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  word-break: break-all;
  -webkit-user-select: all;
          user-select: all;
}
.pp-webhook-copy {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 12px; font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s;
}
.pp-webhook-copy:hover { background: var(--bg-tertiary, #f0f0f3); }
.pp-webhook-events {
  font-size: 11px; color: var(--text-secondary);
}
.pp-webhook-events code {
  display: inline-block;
  background: var(--bg-secondary);
  padding: 1px 6px;
  margin: 0 4px 2px 0;
  border-radius: 3px;
  font-size: 10px; font-weight: 600;
  color: var(--text-primary);
}

/* ─── Revolut Business one-time setup buttons ─── */
.pp-bsetup {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 12px 14px;
  background: var(--bg-tertiary, #f7f8fb);
  display: flex; flex-direction: column; gap: 8px;
}
.pp-bsetup-row { display: flex; gap: 8px; flex-wrap: wrap; }
.pp-bsetup-btn {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  font-size: 13px; font-weight: 600;
  padding: 9px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s;
}
.pp-bsetup-btn:hover:not(:disabled) { border-color: #E94B6C; }
.pp-bsetup-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.pp-bsetup-msg { font-size: 12px; color: #14764e; line-height: 1.5; }
.pp-bsetup-err { font-size: 12px; color: #c1392b; line-height: 1.5; }
.pp-bsetup-hint {
  font-size: 11px; color: var(--text-secondary); line-height: 1.5;
  border-top: 1px solid var(--border-color);
  padding-top: 8px;
  margin-top: 2px;
}

/* ─── Settlement accounts rows ─── */
.pp-acc-row {
  display: grid;
  grid-template-columns: 1fr 70px 1fr 1fr 32px;
  gap: 8px; align-items: center;
}
.pp-acc-row input {
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  font-family: ui-monospace, monospace;
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.pp-acc-row input:focus { outline: none; border-color: #E94B6C; }
.pp-acc-del {
  width: 28px; height: 28px;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}
.pp-acc-del:hover { background: #fee; color: #c1392b; border-color: #f5cdd2; }

/* ─── Footer: TOTP input alongside actions ─── */
.pp-totp-group {
  display: flex; flex-direction: column; gap: 4px;
}
.pp-totp-group label {
  font-size: 11px; font-weight: 700; color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.4px;
}
.pp-totp {
  width: 110px;
  font-family: ui-monospace, monospace;
  font-size: 18px; font-weight: 600;
  letter-spacing: 4px;
  text-align: center;
  padding: 8px 10px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  outline: none;
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.pp-totp:focus { border-color: #E94B6C; }

/* ─── Audit action chips ─── */
.pp-action-tag {
  display: inline-block;
  font-size: 10px; font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  background: var(--bg-tertiary, #f0f0f3);
  color: var(--text-secondary);
  text-transform: uppercase;
}
.pp-action-tag.create { background: #e8f7ef; color: #14764e; }
.pp-action-tag.update { background: #fff3d0; color: #8a6700; }
.pp-action-tag.delete { background: #fde8e8; color: #c1392b; }

.pp-success-msg {
  background: #e8f7ef;
  color: #14764e;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/payment-profiles.css"],"names":[],"mappings":"AAAA;;;+DAG+D;;AAE/D,gDAAgD;AAChD;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,4BAA4B;EAC5B,yBAAyB,EAAE,qBAAqB;AAClD;AACA,aAAa,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC5F;EACE,eAAe,EAAE,gBAAgB,EAAE,0BAA0B;EAC7D,kCAAkC;EAClC,8DAA8D;EAC9D,6BAA6B,EAAE,qBAAqB;EACpD,oCAAoC;AACtC;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA,wBAAwB,uCAAuC,EAAE;AACjE,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE;EACE,SAAO;EACP,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE,gBAAgB;EACjC,kCAAkC;EAClC,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,qBAAqB,qBAAqB,EAAE;AAC5C,aAAa,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC9E;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,oBAAoB,qBAAqB,EAAE;AAC3C,iBAAiB,aAAa,EAAE,QAAQ,EAAE,yBAAyB,EAAE;AACrE;EACE,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,YAAY,EAAE,eAAe;AAC/B;AACA,gBAAgB,+BAA+B,EAAE,4BAA4B,EAAE,qCAAqC,EAAE;AACtH,cAAc,0EAA0E,EAAE,WAAW,EAAE;AACvG,+CAA+C,aAAa,EAAE,mBAAmB,EAAE;AACnF,eAAe,eAAe,EAAE,cAAc,EAAE;AAChD,cAAc,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAE/E,oDAAoD;AACpD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,gDAAgD;AAClD;AACA;EACE,6DAA6D;EAC7D,qCAAqC;AACvC;AACA;EACE,6DAA6D;EAC7D,qCAAqC;AACvC;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,SAAS;EACjD,eAAe;AACjB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE;EACE,eAAe,EAAE,gBAAgB;EACjC,0BAA0B;AAC5B;AACA,yCAAyC,cAAc,EAAE;AACzD;EACE,eAAe,EAAE,gBAAgB;EACjC,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,aAAa,EAAE,QAAQ;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB,EAAE,YAAY;EAC9B,kBAAkB;EAClB,eAAe,EAAE,gBAAgB;EACjC,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;AAC7C;AACA,oBAAoB,0BAA0B,EAAE;AAChD;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa,EAAE,sBAAsB,EAAE,SAAS;AAClD;;AAEA;EACE,SAAS;EACT,eAAe,EAAE,4BAA4B;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;AACA,kBAAkB,0BAA0B,EAAE;;AAE9C,sDAAsD;AACtD;EACE,qBAAqB;EACrB,cAAc,EAAE,gBAAgB;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE,cAAc;EACnC,kBAAkB,EAAE,qBAAqB;EACzC,sBAAsB;AACxB;;AAEA;;sCAEsC;AACtC;;EAEE,WAAW;EACX,kBAAkB;EAClB,gEAAgE;EAChE,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;AACvB;AACA,4BAA4B,4BAA4B,EAAE,YAAY,EAAE;;AAExE,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,0BAA0B;AAC5B;AACA;EACE,aAAa,EAAE,QAAQ,EAAE,mBAAmB;AAC9C;AACA;EACE,SAAO;EACP,gEAAgE;EAChE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE,gBAAgB;EACjC,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,yBAAyB,uCAAuC,EAAE;AAClE;EACE,eAAe,EAAE,4BAA4B;AAC/C;AACA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe,EAAE,gBAAgB;EACjC,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA,iBAAiB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC3D;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;AACA,sCAAsC,qBAAqB,EAAE;AAC7D,0BAA0B,aAAa,EAAE,mBAAmB,EAAE;AAC9D,iBAAiB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpE,iBAAiB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpE;EACE,eAAe,EAAE,4BAA4B,EAAE,gBAAgB;EAC/D,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ,EAAE,mBAAmB;AAC/B;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,0BAA0B,aAAa,EAAE,qBAAqB,EAAE;AAChE;EACE,WAAW,EAAE,YAAY;EACzB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,oBAAoB,gBAAgB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE7E,iDAAiD;AACjD;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B;EAC/D,yBAAyB,EAAE,qBAAqB;AAClD;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,eAAe,EAAE,gBAAgB;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,iBAAiB,qBAAqB,EAAE;;AAExC,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,eAAe,EAAE,gBAAgB;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Payment Profiles page — only the bits that aren't already in\n   regional-offices.css / reports.css. The page reuses .header,\n   .reports-layout, .filters-panel, .offices-table, .offices-modal,\n   .offices-form-* etc. Everything below is profile-specific. */\n\n/* ─── Global FX margin card (page header) ─── */\n.pp-fx-card {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 14px 16px;\n  min-width: 240px;\n  display: flex; flex-direction: column; gap: 8px;\n}\n.pp-fx-label {\n  font-size: 11px; font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase; letter-spacing: 0.5px;\n}\n.pp-fx-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }\n.pp-fx-value {\n  font-size: 22px; font-weight: 800; color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n  background: linear-gradient(135deg, #FF6B4A, #E94B6C, #8E3A9A);\n  -webkit-background-clip: text; background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.pp-fx-edit-btn {\n  font-size: 12px; font-weight: 600;\n  padding: 6px 12px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border-radius: 7px;\n  cursor: pointer;\n}\n.pp-fx-edit-btn:hover { background: var(--bg-tertiary, #f5f6fa); }\n.pp-fx-edit { display: flex; flex-direction: column; gap: 8px; }\n.pp-fx-edit-row { display: flex; align-items: center; gap: 6px; }\n.pp-fx-input {\n  flex: 1;\n  border: 1px solid var(--border-color);\n  border-radius: 7px;\n  padding: 8px 10px;\n  font-size: 16px; font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  outline: none;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n.pp-fx-input:focus { border-color: #E94B6C; }\n.pp-fx-pct { font-size: 14px; font-weight: 600; color: var(--text-secondary); }\n.pp-fx-totp {\n  border: 1px solid var(--border-color);\n  border-radius: 7px;\n  padding: 8px 10px;\n  font-family: ui-monospace, monospace;\n  font-size: 14px;\n  letter-spacing: 3px;\n  text-align: center;\n  outline: none;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n.pp-fx-totp:focus { border-color: #E94B6C; }\n.pp-fx-actions { display: flex; gap: 6px; justify-content: flex-end; }\n.pp-fx-cancel, .pp-fx-save {\n  font-size: 12px; font-weight: 600;\n  padding: 7px 14px;\n  border-radius: 7px;\n  border: none; cursor: pointer;\n}\n.pp-fx-cancel { background: var(--bg-secondary); color: var(--text-secondary); border: 1px solid var(--border-color); }\n.pp-fx-save { background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%); color: #fff; }\n.pp-fx-save:disabled, .pp-fx-cancel:disabled { opacity: 0.55; cursor: not-allowed; }\n.pp-fx-error { font-size: 11px; color: #c1392b; }\n.pp-fx-hint { font-size: 11px; color: var(--text-secondary); line-height: 1.4; }\n\n/* ─── Master active toggle (top of the modal) ─── */\n.pp-active-banner {\n  border-radius: 12px;\n  padding: 14px 16px;\n  margin-bottom: 18px;\n  border: 1px solid var(--border-color);\n  transition: background 0.15s, border-color 0.15s;\n}\n.pp-active-banner.on {\n  background: linear-gradient(180deg, #f4faf6 0%, #ffffff 100%);\n  border-color: rgba(20, 118, 78, 0.25);\n}\n.pp-active-banner.off {\n  background: linear-gradient(180deg, #fef0f1 0%, #fff8f8 100%);\n  border-color: rgba(193, 57, 43, 0.25);\n}\n.pp-active-toggle-row {\n  display: flex; align-items: flex-start; gap: 12px;\n  cursor: pointer;\n}\n.pp-active-toggle-row input[type=\"checkbox\"] {\n  width: 20px; height: 20px;\n  accent-color: #E94B6C;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n.pp-active-text { display: flex; flex-direction: column; gap: 3px; }\n.pp-active-title {\n  font-size: 14px; font-weight: 700;\n  color: var(--text-primary);\n}\n.pp-active-banner.off .pp-active-title { color: #c1392b; }\n.pp-active-sub {\n  font-size: 12px; line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n/* ─── Tabs inside the modal ─── */\n.pp-tabs-row {\n  display: flex; gap: 2px;\n  border-bottom: 1px solid var(--border-color);\n  margin: 8px 0 16px;\n  flex-wrap: wrap;\n}\n.pp-tab-btn {\n  background: none; border: none;\n  padding: 10px 14px;\n  font-size: 13px; font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.12s, border-color 0.12s;\n}\n.pp-tab-btn:hover { color: var(--text-primary); }\n.pp-tab-btn.active {\n  color: var(--text-primary);\n  border-bottom-color: #E94B6C;\n}\n\n.pp-tab-pane {\n  display: flex; flex-direction: column; gap: 14px;\n}\n\n.pp-hint {\n  margin: 0;\n  font-size: 12px; color: var(--text-secondary);\n  line-height: 1.5;\n  padding: 10px 12px;\n  background: var(--bg-tertiary, #f7f7f9);\n  border-radius: 8px;\n}\n.pp-hint strong { color: var(--text-primary); }\n\n/* ─── Secret tag inline next to the field label ─── */\n.pp-secret-tag {\n  display: inline-block;\n  font-size: 9px; font-weight: 800;\n  padding: 2px 5px;\n  margin-left: 8px;\n  background: #fff3f4; color: #E94B6C;\n  border-radius: 3px; letter-spacing: 0.6px;\n  vertical-align: middle;\n}\n\n/* The shared regional-offices.css only styles input/select inside\n   .offices-form-field — textarea inherits browser defaults (huge font,\n   no padding). Cover it explicitly. */\n.offices-form-field textarea,\n.pp-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 12px;\n  line-height: 1.45;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n  resize: vertical;\n}\n.offices-form-field textarea:focus,\n.pp-textarea:focus {\n  border-color: #E94B6C;\n}\n.pp-textarea::placeholder { color: var(--text-secondary); opacity: 0.6; }\n\n/* ─── Webhook URL box ─── */\n.pp-webhook-box {\n  border: 1px solid var(--border-color);\n  border-left: 3px solid #E94B6C;\n  border-radius: 8px;\n  padding: 12px 14px;\n  background: rgba(233, 75, 108, 0.04);\n  display: flex; flex-direction: column; gap: 8px;\n}\n.pp-webhook-label {\n  font-size: 12px; font-weight: 600;\n  color: var(--text-primary);\n}\n.pp-webhook-url-row {\n  display: flex; gap: 8px; align-items: center;\n}\n.pp-webhook-url {\n  flex: 1;\n  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 12px;\n  background: var(--bg-secondary);\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n  word-break: break-all;\n  user-select: all;\n}\n.pp-webhook-copy {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-size: 12px; font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s;\n}\n.pp-webhook-copy:hover { background: var(--bg-tertiary, #f0f0f3); }\n.pp-webhook-events {\n  font-size: 11px; color: var(--text-secondary);\n}\n.pp-webhook-events code {\n  display: inline-block;\n  background: var(--bg-secondary);\n  padding: 1px 6px;\n  margin: 0 4px 2px 0;\n  border-radius: 3px;\n  font-size: 10px; font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* ─── Revolut Business one-time setup buttons ─── */\n.pp-bsetup {\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 12px 14px;\n  background: var(--bg-tertiary, #f7f8fb);\n  display: flex; flex-direction: column; gap: 8px;\n}\n.pp-bsetup-row { display: flex; gap: 8px; flex-wrap: wrap; }\n.pp-bsetup-btn {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  font-size: 13px; font-weight: 600;\n  padding: 9px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s;\n}\n.pp-bsetup-btn:hover:not(:disabled) { border-color: #E94B6C; }\n.pp-bsetup-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n.pp-bsetup-msg { font-size: 12px; color: #14764e; line-height: 1.5; }\n.pp-bsetup-err { font-size: 12px; color: #c1392b; line-height: 1.5; }\n.pp-bsetup-hint {\n  font-size: 11px; color: var(--text-secondary); line-height: 1.5;\n  border-top: 1px solid var(--border-color);\n  padding-top: 8px;\n  margin-top: 2px;\n}\n\n/* ─── Settlement accounts rows ─── */\n.pp-acc-row {\n  display: grid;\n  grid-template-columns: 1fr 70px 1fr 1fr 32px;\n  gap: 8px; align-items: center;\n}\n.pp-acc-row input {\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-family: ui-monospace, monospace;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n.pp-acc-row input:focus { outline: none; border-color: #E94B6C; }\n.pp-acc-del {\n  width: 28px; height: 28px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n.pp-acc-del:hover { background: #fee; color: #c1392b; border-color: #f5cdd2; }\n\n/* ─── Footer: TOTP input alongside actions ─── */\n.pp-totp-group {\n  display: flex; flex-direction: column; gap: 4px;\n}\n.pp-totp-group label {\n  font-size: 11px; font-weight: 700; color: var(--text-secondary);\n  text-transform: uppercase; letter-spacing: 0.4px;\n}\n.pp-totp {\n  width: 110px;\n  font-family: ui-monospace, monospace;\n  font-size: 18px; font-weight: 600;\n  letter-spacing: 4px;\n  text-align: center;\n  padding: 8px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  outline: none;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n.pp-totp:focus { border-color: #E94B6C; }\n\n/* ─── Audit action chips ─── */\n.pp-action-tag {\n  display: inline-block;\n  font-size: 10px; font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 4px;\n  background: var(--bg-tertiary, #f0f0f3);\n  color: var(--text-secondary);\n  text-transform: uppercase;\n}\n.pp-action-tag.create { background: #e8f7ef; color: #14764e; }\n.pp-action-tag.update { background: #fff3d0; color: #8a6700; }\n.pp-action-tag.delete { background: #fde8e8; color: #c1392b; }\n\n.pp-success-msg {\n  background: #e8f7ef;\n  color: #14764e;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
